import { LowerBidder, TopBidderRibbon } from '../../../components/ribbon'
import useVehiclePageData from '../use-vehicle-page-data'

export default function BidderBadge() {
  const { auctionInfo } = useVehiclePageData()

  if (!auctionInfo || auctionInfo.currentUserBidAmount == null) return null

  return (
    <div className='bidderBadge flex justifyCenter'>
      {auctionInfo.currentUserIsTopBidder ? (
        <TopBidderRibbon size='lg' />
      ) : (
        <LowerBidder
          size='lg'
          difference={auctionInfo.topBidAmount - auctionInfo.currentUserBidAmount}
        />
      )}
    </div>
  )
}
